
























import { computed, defineComponent, PropType } from '@vue/composition-api'

// components
import FormCreateCessationEmployee from './FormCreateCessation.vue'
import HistoryCessationAndReEntry from './HistoryCessationAndReEntry.vue'

// models
import { CessationHistoryModel, EmployeeModel, ReasonForTerminationWorkModel } from '@/models/config'

export default defineComponent({
  name: 'ModalCessationEmployee',
  components: {
    FormCreateCessationEmployee,
    HistoryCessationAndReEntry
  },
  props: {
    show: {
      type: Boolean as PropType<boolean>
    },
    employee: {
      type: Object as PropType<EmployeeModel>,
      required: true
    },
    reasons: {
      type: Array as PropType<ReasonForTerminationWorkModel[]>,
      required: true
    },
    type: {
      type: Number as PropType<number>,
      required: true
    },
    itemEdit: {
      type: Object as PropType<CessationHistoryModel>,
      default: () => null
    }
  },
  setup (props) {
    const typeAction = computed(() => {
      return props.type
    })
    const title = computed(() => {
      return (typeAction.value === 0) ? 'Cese de Trabajador' : 'Reingreso de Trabajador'
    })
    return {
      title,
      typeAction
    }
  }
})
